<template>
  <button v-on:click="toggleClosed" type="button" class="align-middle inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"  style="height: 41px;margin-top: 3px;">
    <ReplyIcon v-if="isClosed" class="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" />
    <CheckIcon v-else class="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" />
    <span v-if="isClosed">{{ $t('conversation.open') }}</span><span v-else>{{ $t('conversation.resolve') }}</span>
  </button>
  <ResolveReasonSelector v-if="showSelector" v-on:resolve-done="closeSelector" v-on:resolve-cancel="closeSelector" :conversation="conversation" />
  <OpenSelector v-if="showOpen" v-on:open-done="closeOpen" :conversation="conversation" />
</template>

<script>
import ResolveReasonSelector from './ResolveReasonSelector.vue'
import OpenSelector from './OpenSelector.vue'

import { useReasonForResolvingStore } from '@/stores/reasonForResolving';

import {
  CheckIcon,
  ReplyIcon,
} from '@heroicons/vue/outline'

export default {
  name: 'ResolveConversation',
  props: ['conversation'],
  emits: ['toggle-closed'],
  setup() {
    let reasonStore = useReasonForResolvingStore();
    return { reasonStore };
  },
  components: {
    ResolveReasonSelector,
    OpenSelector,
    //
    CheckIcon,
    ReplyIcon,
  },
  methods: {
    toggleClosed() {
      if (this.hasReasons && !this.isClosed) {
        this.showSelector = true;
      } else if (this.isClosed) {
        this.showOpen = true;
      } else {
        this.$emit('toggle-closed');
      }
    },
    closeSelector() {
      this.showSelector = false;
    },
    closeOpen() {
      this.showOpen = false;
    },
  },
  computed: {
    isClosed() {
      return this.conversation.status === 'closed';
    },
    hasReasons() {
      return this.reasonStore.collection.length > 0;
    }
  },
    data() {
    return {
      showSelector: false,
      showOpen: false,
    }
  },
}
</script>
